module.exports = __webpack_public_path__ + "img/lm_logo.87a1f3880eda82da1383c749a22bdcaf.svg";